import { motion } from 'framer-motion';
import { STATS } from '../../lib/site';
import { TEAM_AVATARS } from '../../lib/imagery';

// Non-numeric proof cards (no invented statistics)
export default function StatsStrip() {
    return (
        <section
            data-testid="home-stats-strip"
            className="relative"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Human anchor — small team avatars strip */}
                <div className="flex items-center justify-center sm:justify-start gap-4 pb-4">
                    <div className="flex -space-x-3">
                        {TEAM_AVATARS.slice(0, 5).map((src, idx) => (
                            <img
                                key={src}
                                src={src}
                                alt=""
                                aria-hidden
                                loading="lazy"
                                className="h-9 w-9 rounded-full object-cover border-2 border-[rgb(8,12,20)] shadow-[0_0_0_1px_rgba(0,229,255,0.35)] grayscale-[35%]"
                                style={{ filter: 'saturate(0.7) contrast(1.05)' }}
                                onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                        ))}
                    </div>
                    <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-muted-foreground">
                        Senior-led delivery teams · Africa &amp; Europe
                    </div>
                </div>

                <div className="dt-glass rounded-2xl p-3 sm:p-4 lg:p-5 grid grid-cols-2 lg:grid-cols-4 gap-3">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.label}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-60px' }}
                            transition={{ duration: 0.5, delay: i * 0.05 }}
                            className="relative rounded-xl bg-[rgba(255,255,255,0.025)] border border-white/5 p-4 sm:p-5"
                            data-testid={`stat-${(s.label || '').toLowerCase().replaceAll(' ', '-')}`}
                        >
                            <div className="text-2xl sm:text-3xl font-semibold tracking-tight font-display text-primary">
                                {s.value}
                            </div>
                            <div className="mt-2 text-sm text-foreground/90 font-medium">{s.label}</div>
                            <div className="mt-0.5 text-[11px] font-mono uppercase tracking-widest text-muted-foreground">{s.sub}</div>
                            <span className="absolute right-3 top-3 h-1.5 w-1.5 rounded-full bg-primary/70" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
